module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "h1",
    staticStyle: {
      "color": "#82a339"
    },
    attrs: {
      "id": "d7e837330"
    }
  }, [_c('b', [_vm._v("ROASTED RED PEPPER DIP")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e837830"
    }
  }, [_c('b', [_c('i', [_vm._v("Fresh roasted red peppers are what make this dip special, so don’t substitute the ones that come in a jar. Roasting peppers is easy to do. If you’ve never done it, this is the perfect opportunity. Once you’ve tasted them, you’ll wonder why you waited so long.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e839730"
    }
  }, [_c('b', [_vm._v("Prep: 45 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e840230"
    }
  }, [_vm._v("4 red peppers, roasted")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e840530"
    }
  }, [_vm._v("½ teaspoon ground cumin")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e841430"
    }
  }, [_vm._v("½ cup walnuts, toasted")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e842430"
    }
  }, [_vm._v("2 slices firm white bread, torn into pieces")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e842730"
    }
  }, [_vm._v("2 tablespoons raspberry or balsamic vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e843030"
    }
  }, [_vm._v("1 tablespoon olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e843330"
    }
  }, [_vm._v("½ teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e844330"
    }
  }, [_vm._v("⅛ teaspoon ground red pepper (cayenne) "), _c('br'), _vm._v(" toasted pita bread wedges")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "d7e845730"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" Cut roasted peppers into large pieces. In small skillet, toast cumin over low heat, stirring constantly, until very fragrant, 1 to 2 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e847030"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" In food processor with knife blade attached, process walnuts until ground. Add roasted peppers, cumin, bread, vinegar, oil, salt, and ground red pepper; puree until smooth. Transfer to bowl. If not serving right away, cover and refrigerate up to 4 hours. Serve with toasted pita bread wedges. Makes about 2 cups.")]), _vm._v(" "), _c('p', {
    staticClass: "ntx",
    attrs: {
      "id": "d7e849730"
    }
  }, [_vm._v("Each tablespoon: About 23 calories, 0g protein, 2g carbohydrate, 2g total fat (0g saturated), 0mg cholesterol, 46mg sodium.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9781618371621_0030_001",
      "src": "Images/9781618371621_0030_001.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap",
    attrs: {
      "id": "d7e850930"
    }
  }, [_c('i', [_vm._v("Roasted Red Pepper Dip")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c45bb02","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/West_9781618371621_epub_c10_r1.vue
// module id = 96
// module chunks = 0